import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { motion } from "framer-motion";
import { EditNote, Insights, HealthAndSafety } from "@mui/icons-material";

const steps = [
  {
    icon: <EditNote fontSize="large" color="primary" />,
    title: "1. Log Your Lab Results",
    description: "Add your test values like creatinine, eGFR, potassium, and more — all in seconds.",
  },
  {
    icon: <Insights fontSize="large" color="primary" />,
    title: "2. Visualize Health Trends",
    description: "Get clean graphs and trend lines to see how your health is changing over time.",
  },
  {
    icon: <HealthAndSafety fontSize="large" color="primary" />,
    title: "3. Get Smart Health Guidance",
    description: "Our AI checks patterns and alerts you to potential risks or improvements.",
  },
];

export default function HowItWorks() {
  return (
    <Box sx={{ py: 10, px: 2, backgroundColor: "#fff" }}>
      <Typography variant="h4" align="center" fontWeight="bold" gutterBottom>
        How It Works
      </Typography>
      <Typography variant="body1" align="center" sx={{ mb: 6 }}>
        Your health journey simplified into three easy steps.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {steps.map((step, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.3 }}
              viewport={{ once: true }}
            >
              <Paper
                elevation={3}
                sx={{
                  p: 4,
                  textAlign: "center",
                  borderRadius: 4,
                  height: "100%",
                }}
              >
                <Box mb={2}>{step.icon}</Box>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {step.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {step.description}
                </Typography>
              </Paper>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}